import { css } from 'styled-components'
import { withPrefix } from 'gatsby'

export default function ({
  headingWrapperProps,
  imageWrapperProps,
}) {
  return {
    triangleProps: {
      clipReversed: false,
      clipDisabled: true,
    },
    wrapperProps: {
      backgroundImage: true,
      clipDisabled: true,
      mobileWrapperStyles: css`
        ${ ({ theme }) => css`
          height: 280px;
          ::before {
            background: linear-gradient(179.44deg, #000000 -26.82%, rgba(0, 0, 0, 0.54) 111.09%), url(${ withPrefix('img/ArHeroHeaderCompanyCareers.jpg') });
            background-position: center;
            background-size: cover;
            bottom: 0;
            content: '';
            left: 0;
            position: absolute;
            right: 0;
            top: -${ theme.headerHeight.mobile }px;
            z-index: -1;
          }
        ` }
      `,
      tabletWrapperStyles: css`
        height: 400px;
        ::before {
            top: -${ ({ theme }) => theme.headerHeight.tablet }px;
        }
      `,
      desktopWrapperStyles: css`
        align-items: center;
        display: flex;
        height: 700px;
      `,
    },
    containerProps: {
      mobileContainerStyles: null,
      tabletContainerStyles: null,
      desktopContainerStyles: null,
    },
    headingWrapperProps: {
      ...headingWrapperProps,
      alignTextToCenter: true,
      centerButton: true,
      buttonVariant: 'outline-bold',
      mobileContainerStyles: css`
        margin-top: 30px;
      `,
      tabletContainerStyles: css`
        margin-top: 50px;
        width: 60%;
      `,
      desktopContainerStyles: css`
        margin-top: -50px;
        width: 490px;
      `,
    },
    imageWrapperProps: {
      ...imageWrapperProps,
      imageMobile: null,
      imageTablet: null,
      imageDesktop: null,
      mobileImageWrapperStyles: null,
      tabletImageWrapperStyles: null,
      desktopImageWrapperStyles: null,
      mobileImageStyles: null,
      tabletImageStyles: null,
      desktopImageStyles: null,
    },
  }
}
